import { QSetStatus } from '@report/graphql';
import { z } from 'zod';

export const questionUsageByQSetReportFilterFormSchema = z.object({
  examCourse: z.object(
    {
      value: z.string(),
      label: z.string(),
    },
    { message: 'กรุณาเลือกคลังข้อสอบ' },
  ),
  qSetStatus: z.object(
    {
      value: z.nativeEnum(QSetStatus),
      label: z.string(),
    },
    { message: 'กรุณาเลือกสถานะชุดข้อสอบ' },
  ),
});

export type QuestionUsageByQSetReportFilterFormInput = z.infer<
  typeof questionUsageByQSetReportFilterFormSchema
>;
